import { render, staticRenderFns } from "./Structuredcabling.vue?vue&type=template&id=c1e87c50&scoped=true&"
import script from "./Structuredcabling.vue?vue&type=script&lang=js&"
export * from "./Structuredcabling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e87c50",
  null
  
)

export default component.exports